import { render, staticRenderFns } from "./AutoCompleteFormTags.vue?vue&type=template&id=15860d5c&"
import script from "./AutoCompleteFormTags.vue?vue&type=script&lang=ts&"
export * from "./AutoCompleteFormTags.vue?vue&type=script&lang=ts&"
import style0 from "./AutoCompleteFormTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports